import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { About } from '../features/sections/About.js';
import { Approach } from '../features/sections/Approach.js';
import { HireBand } from '../features/sections/HireBand.js';
import { Offers } from '../features/sections/Offers.js';
import { Stats } from '../features/sections/Stats.js';
import { Work } from '../features/sections/Work.js';
import { Footer } from '../features/shell/Footer.js';
import { Header } from '../features/shell/Header.js';
import { Hero } from '../features/shell/Hero.js';
import { MobileBar } from '../features/shell/MobileBar.js';
import { applyDocumentLocale, normaliseLocale } from '../i18n/config.js';

/**
 * A single scrolling page. The design has no routes — the header anchors
 * within the document — so there is no router.
 */
export function App() {
  const { t, i18n } = useTranslation(['common']);
  const locale = normaliseLocale(i18n.resolvedLanguage);

  // Watched by the header to decide when it has left the hero and needs a
  // background of its own.
  const sentinel = useRef<HTMLDivElement>(null);

  // main.tsx sets this before the first paint; this keeps it in step when the
  // visitor switches language.
  useEffect(() => {
    applyDocumentLocale(locale, document.documentElement);
  }, [locale]);

  return (
    <div className="frame" id="top">
      <a className="skip-link" href="#work">
        {t('common:skipToContent')}
      </a>
      <div ref={sentinel} className="hero-sentinel" aria-hidden="true" />
      <Header sentinel={sentinel} />
      <Hero />
      <main>
        <Stats />
        <Work />
        <Approach />
        <About />
        <HireBand />
        <Offers />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
